<template>
	<div>
		<NetworkMessages ref="messages" />
		<router-view @show-message="showMessage" />
	</div>
</template>

<script>
import NetworkMessages from '@/components/admin/NetworkMessages'

export default {
	name: 'AdminContainer',
	components: {
		NetworkMessages,
	},
	methods: {
		showMessage(message) {
			this.$refs.messages.showMessage(message)
		},
	},
}
</script>